module.exports = __webpack_public_path__ + "img/soren.4ae92101.png";